import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import "@/i18n";
import App from "@/App";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { registerServiceWorker } from "@/serviceWorkerRegistration";

const QUERY_STALE_TIME_MS = 60_000;

// Root-cause fix for the recurring benign "ResizeObserver loop
// completed/limit exceeded" warning (fired by Radix/shadcn Select and Dialog
// components on resize) that webpack-dev-server's own error overlay client
// escalates into a full-screen dev overlay capable of swallowing real
// clicks. Simply listening for the resulting window 'error' event doesn't
// reliably beat webpack-dev-server's own listener (registered earlier in
// the page's script order), so instead we patch ResizeObserver itself to
// defer its callback to the next animation frame, which prevents the
// browser from ever hitting the notification loop that triggers the
// warning in the first place. No-op in production (dev-only artifact).
if (window.ResizeObserver) {
  const NativeResizeObserver = window.ResizeObserver;
  window.ResizeObserver = class extends NativeResizeObserver {
    constructor(callback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => callback(entries, observer));
      });
    }
  };
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: QUERY_STALE_TIME_MS,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);

registerServiceWorker();
